(function () {
  'use strict';

  let angular = window.angular;

  TelegramChatConfigurationController.$inject = [
    '$rootScope',
    'Customer',
    '$timeout',
    '$state',
    '$uibModal',
    'assetUtilsService',
    'AppUtils',
  ];

  angular.module('app').component('connectionTelegramChat', {
    template:'<view-sidebar><view-sidebar-title><span translate>entities.telegramchat.modelName</span><div class="btn-group btn-group-sm pull-right"><a class="btn btn-primary" title="{{:: \'buttons.new\' | translate}} {{:: \'entities.telegramchat.modelName\' | translate}}" ng-click="ctrl.showTelegramChatForm(null, null)"><i class="fas fa-plus"></i></a> <a class="btn btn-primary btn-sm" ng-class="{disabled: !ctrl.telegramChatId}" ui-sref=".({telegramChatId: null})"><i class="fas fa-ban"></i></a></div></view-sidebar-title><view-sidebar-content><js-tree data="ctrl.telegramChatsTree" selected="ctrl.telegramChatId" on-select="ctrl.onSelectTelegramChat(selected)"></js-tree><div class="absolute" ng-if="ctrl.loading"></div></view-sidebar-content></view-sidebar><div><view-sidebar-toggle></view-sidebar-toggle><div ng-hide="ctrl.telegramChatSelected || ctrl.loading"><h1 class="centered-message no-margin"><i class="fas fa-arrow-circle-left"></i> <span translate>general._select.an</span> <span translate>entities.telegramchat.modelName</span></h1></div><div ng-if="ctrl.telegramChatSelected" ng-show="!ctrl.loading"><div class="asset-profile"><div class="padding20"><div class="asset-name"><div><h2 title="{{ctrl.telegramChatSelected.name}}">{{ctrl.telegramChatSelected.name}}</h2><div class="btn-group"><a class="btn btn-primary btn-sm" ng-click="ctrl.showTelegramChatForm(ctrl.telegramChatSelected)"><i class="fas fa-edit"></i></a> <a class="btn btn-danger btn-sm" ng-click="ctrl.confirmRemoveTelegramChat(ctrl.telegramChatSelected)"><i class="fas fa-trash"></i></a></div><div class="clearfix"></div></div></div><table class="table no-margin table-description"><thead><tr><th colspan="4" class="no-padding"></th></tr></thead><tbody><tr class="bordered"><td class="field">Id</td><td colspan="3" class="clipboard" style="cursor: copy" clipboard data-text="ctrl.telegramChatSelected.id">{{ctrl.telegramChatSelected.id}} <button class="btn btn-default btn-sm btn-clipboard" title="Copy to clipboard"><i class="fas fa-copy"></i></button></td></tr><tr class="bordered"><td class="field">Telegram Chat Id</td><td colspan="3" class="clipboard" style="cursor: copy" clipboard data-text="ctrl.telegramChatSelected.chatId">{{ctrl.telegramChatSelected.chatId}} <button class="btn btn-default btn-sm btn-clipboard" title="Copy to clipboard"><i class="fas fa-copy"></i></button></td></tr><tr><td class="field" translate>entities._all.description</td><td colspan="3" data-label="Description" class="block"><div class="asset-description" data-label="{{:: \'buttons.expand\' | translate}}" ng-class="{\'opened\': ctrl.showDescription, \'gradient\': ctrl.telegramChatSelected.description}" ng-click="ctrl.showDescription = true"><div id="telegramChatDescription" class="markdown" markdown-to-html="ctrl.telegramChatSelected.description || \'\'"></div></div><div ng-if="ctrl.showDescription" style="text-align: center" class="asset-description"><a class="contraction-text" ng-click="ctrl.showDescription=false" translate>buttons.hide</a></div></td></tr></tbody></table></div></div></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small\'"></spinner></div>',
    controller: TelegramChatConfigurationController,
    controllerAs: 'ctrl',
    bindings: {
      $transition$: '<',
      telegramChats: '<',
      customer: '<',
    },
  });

  function TelegramChatConfigurationController(
    $rootScope,
    Customer,
    $timeout,
    $state,
    $uibModal,
    assetUtilsService,
    appUtils
  ) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.onSelectTelegramChat = onSelectTelegramChat;

      vm.telegramChatsTree = vm.telegramChats.tree;
      vm.telegramChats = appUtils.arrayToObject(vm.telegramChats.telegramChats, 'id');

      // modals
      vm.showTelegramChatForm = showTelegramChatForm;
      vm.confirmRemoveTelegramChat = confirmRemoveTelegramChat;
      vm.telegramChatSelected = null;

      checkIdParam(vm.$transition$.params().telegramChatId);

      vm.uiOnParamsChanged = function (params) {
        if (params.telegramChatId !== undefined) {
          checkIdParam(params.telegramChatId);
        }
      };
    };

    function showTelegramChatForm(telegramChat) {
      let instance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        bindToController: true,
        keyboard: false,
        component: 'connectionTelegramChatForm',
        resolve: {
          telegramChat: telegramChat,
          customer: vm.customer,
        },
      });

      instance.result
        .then(function (result) {
          if (result.operation === 'create') {
            $state.go('.', { telegramChatId: result.telegramChat.id }, { reload: true });
          } else if (result.operation === 'update') {
            if (telegramChat.name !== result.telegramChat.name) {
              $rootScope.$broadcast('jstree.rename-node', result.node);
            }

            onSelectTelegramChat(result.telegramChat.id);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function onSelectTelegramChat(selected) {
      if (!selected) {
        vm.telegramChatSelected = null;
        return;
      }

      $state.go('.', { telegramChatId: selected });

      vm.loading = true;
      Customer.telegramChats({
        id: vm.customer.id,
        filter: {
          where: { id: selected },
        },
      })
        .$promise.then(function (result) {
          const telegramChat = result[0];

          vm.telegramChatSelected = telegramChat;

          vm.loading = false;
        })
        .catch(function (err) {
          console.log(err);
          vm.loading = false;
        });
    }

    function confirmRemoveTelegramChat(telegramChat) {
      let instance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        windowClass: 'modal-xs modal-warning',
        bindToController: true,
        keyboard: false,
        component: 'connectionTelegramChatRemove',
        resolve: {
          telegramChat: telegramChat,
          customer: vm.customer,
        },
      });

      instance.result
        .then(function () {
          $state.go('.', { telegramChatId: null }, { reload: true });
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function checkIdParam(telegramChatIdParam) {
      if (telegramChatIdParam) {
        if (vm.telegramChats[telegramChatIdParam]) {
          vm.telegramChatId = telegramChatIdParam;
        } else {
          $state.go('.', { telegramChatId: null });
        }
      } else {
        vm.telegramChatId = null;
      }
    }
  }
})();
